document.addEventListener('DOMContentLoaded', function() {
  if (document.getElementsByClassName('main-slider')){
    $('body').addClass('content-main-slider');
  }
  if (document.getElementsByClassName('main-header')){
    $('body').addClass('content-main-header');
  }
  $('p').each(function() {
    if ($(this).children('iframe[title="YouTube video player"]').length) {
      $(this).addClass('content-iframe-youtube');
    }
  });
});
